import { f as o } from "./fails.js";
import { i as t } from "./is-callable.js";
import { i as r } from "./is-object.js";
import "./object-create.js";
import { o as e } from "./object-get-prototype-of.js";
import { d as i } from "./define-built-in.js";
import { w as s } from "./well-known-symbol.js";
var a,
  m,
  p,
  f = s("iterator"),
  n = !1;
[].keys && ("next" in (p = [].keys()) ? (m = e(e(p))) !== Object.prototype && (a = m) : n = !0), (!r(a) || o(function () {
  var o = {};
  return a[f].call(o) !== o;
})) && (a = {}), t(a[f]) || i(a, f, function () {
  return this;
});
var j = {
  IteratorPrototype: a,
  BUGGY_SAFARI_ITERATORS: n
};
export { j as i };